const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
};

const state = () => ({
  toasts: [],
  showModal: false,
  modal: {
    title: "",
    message: "",
    type: "",
    icon: null,
  },
});

const mutations = {
  SET_MODAL(state, payload) {
    state.showModal = true;
    state.modal = payload;
  },
  HIDE_MODAL(state) {
    state.showModal = false;
    state.modal.show = {
      title: "",
      message: "",
      icon: null,
    };
  },
  ADD_TOAST(state, payload) {
    state.toasts.push(payload);
  },

  HIDE_TOAST(state, id) {
    const index = state.toasts.findIndex((toast) => toast.id === id);
    if (index !== -1) {
      state.toasts[index].show = false;
    }
  },

  RESET_TOAST(state, id) {
    state.toasts = state.toasts.filter((toast) => toast.id !== id);
  },

  CLEAR_ALL_TOASTS(state) {
    state.toasts = [];
  },
};

const getters = {
  toasts: (state) => {
    return state.toasts;
  },
  modal: (state) => {
    return state.modal;
  },
  showModal: (state) => {
    return state.showModal;
  },
};

const actions = {
  displayToast({ commit }, payload) {
    const toast = {
      id: payload.id || generateId(),
      show: true,
      message: payload.message || "",
      title: payload.title || "",
      type: payload.type || "info",
      icon: payload.icon || null,
      dismissible: payload?.dismissible ? payload.dismissible : true,
      duration: payload?.duration ? payload.duration : 3000,
    };
    commit("ADD_TOAST", toast);
    setTimeout(() => {
      commit("RESET_TOAST", toast.id);
    }, toast.duration);
    return payload.id || generateId();
  },

  resetToast({ commit }, id) {
    commit("RESET_TOAST", id);
  },

  hideToast({ commit }, id) {
    commit("HIDE_TOAST", id);
    setTimeout(() => {
      commit("RESET_TOAST", id);
    }, 500);
  },

  clearAllToasts({ commit }) {
    commit("CLEAR_ALL_TOASTS");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
